import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@ferris/react/components/button';
import { gql } from '@apollo/client';
import { TrackingContext } from '@vrbo/react-event-tracking';
import { retrieveDataNoCache } from '../../../actions/graphQlSvc';
import { createInteractionEvent } from '../../../utils/EventProviders/EgClickstreamUtil';

export const EMAIL_INVITATION_SEND = gql`
query SendEmailVerification($propertyId: String){
    sendEmailVerification(propertyId: $propertyId)
}
`;

export const TYPES = {
    LINK: 'LINK',
    BTN: 'BTN'
};

const ResendEmailBtn = (props) => {
    const { type } = props;
    const {
        text, callbackFn, propertyId
    } = props;

    const [isLoading, setIsLoading] = useState(false);
    const { trigger } = useContext(TrackingContext);


    const resendEmail = async () => {
        trigger('interaction', createInteractionEvent('email_verification_resend.submitted', 'email_verification', '', undefined, '2.3.0'));
        setIsLoading(true);
        try {
            const { error: queryError, data } = await retrieveDataNoCache(EMAIL_INVITATION_SEND, {
                propertyId
            });
            callbackFn(!queryError && data.sendEmailVerification);
        } catch (e) {
            callbackFn(false);
        }
        setIsLoading(false);
    };
    if (type === TYPES.LINK) {
        return (
            <Button
                type="link"
                onClick={resendEmail}
                id="resend-email-btn"
                disabled={isLoading}
            >
                {text}
            </Button>
        );
    }
    return (
        <Button
            id="resend-email-btn"
            onClick={resendEmail}
            disabled={isLoading}
        >
            {text}
        </Button>
    );
};

ResendEmailBtn.propTypes = {
    type: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    callbackFn: PropTypes.func.isRequired,
    propertyId: PropTypes.string.isRequired
};

export default ResendEmailBtn;
